import { FormSelectOption } from '../FormControls';
import { TrailingStopType } from '../TradingForm';
import { ModifyOrderFormTranslationKey } from './ModifyOrderFormContext';

export type ModifyOrderFormSelectOption = Omit<FormSelectOption, 'name'> & {
    name: ModifyOrderFormTranslationKey;
};

export const TRAILING_STOP_PEG_TYPE_OPTIONS: {
    dollar: ModifyOrderFormSelectOption;
    percent: ModifyOrderFormSelectOption;
} = {
    dollar: {
        name: 'trailingStopPegTypeSelect.options.dollar',
        value: TrailingStopType.Dollar,
    },
    percent: {
        name: 'trailingStopPegTypeSelect.options.percent',
        value: TrailingStopType.Percent,
    },
};
